import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';

import { navigate } from '../../../../helpers';
import styles from './sidebar.scss';

const propTypes = {
  onRequestCloseFn: PropTypes.func,
  text: PropTypes.string,
  to: PropTypes.string,
  href: PropTypes.string,
  // onClick: PropTypes.string,
  disabled: PropTypes.bool,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  icon: PropTypes.string,
  onDisabledClick: PropTypes.func,
};

class SidebarItem extends React.Component {
  handleClick = () => {
    const {
      onRequestCloseFn,
      to,
      history,
      href,
    } = this.props;
    onRequestCloseFn();
    if (to) {
      navigate(history, to);
    } else if (href) {
      window.open(href);
    }
  }

  render() {
    const {
      text,
      icon,
      disabled,
      onDisabledClick,
    } = this.props;
    return (
      <div
        role="button"
        tabIndex="0"
        onClick={disabled ? onDisabledClick : () => this.handleClick()}
        className={classNames(
          styles.item,
          { [styles.disabled]: disabled },
        )}
      >
        { icon
          && <i className={`far fa-${icon}`} />}
        <span>
          {text}
        </span>
      </div>
    );
  }
}

SidebarItem.propTypes = propTypes;

export default withRouter(SidebarItem);
